<template>
  <div v-if="standalone" class="legacy-share-page" @click="retryShare">
    <div v-if="codeImage" class="legacy-share-content">
      <img :src="codeImage" alt="微信小程序码" class="legacy-share-image">
      <div class="legacy-share-text">
        <div class="legacy-share-title">请用装有微信的移动设备打开链接</div>
        <div class="legacy-share-subtitle">亦可用微信扫码访问</div>
      </div>
    </div>
    <div v-else-if="failed" class="legacy-share-text" role="status">
      <div class="legacy-share-title">网络异常</div>
      <button type="button" @click.stop="open">重试</button>
    </div>
  </div>
  <div v-else class="mini-entry help-document-theme">
    <button type="button" :disabled="loading" @click="open">{{ failed ? '重试' : '在小程序中查看' }}</button>
    <p v-if="failed" role="status">网络异常</p>
    <div v-if="codeImage" class="mini-entry-code"><img :src="codeImage" alt="微信小程序码"><p>微信扫码查看</p></div>
  </div>
</template>

<script>
import { getMiniUrlLink, getUrlLinkByCode } from '@/request/api'
import { shareEnvironment, miniDestination, inMiniProgram } from '@/utils/shareLanding'
import '@/generated/helpReader.css'

export default {
  name: 'MiniProgramEntry',
  props: { path: String, query: { type: String, default: '' }, standalone: Boolean, code: String, businessCode: Boolean, showQr: Boolean },
  data() { return { loading: false, failed: false, codeImage: '', linkUrl: '' } },
  computed: { targetKey() { return JSON.stringify([this.path, this.query, this.standalone, this.code, this.businessCode]) } },
  watch: { targetKey() { this.initialize() } },
  mounted() { this._alive = true; this.initialize() },
  beforeDestroy() { this._alive = false; this._version++ },
  methods: {
    initialize() {
      this._version = (this._version || 0) + 1
      this.loading = false; this.failed = false; this.codeImage = ''; this.linkUrl = ''
      if (this.standalone) this.open(!shareEnvironment().mobile)
      else if (shareEnvironment().preferMiniProgram) this.open(false)
      else if (this.showQr) this.open(true)
    },
    retryShare() {
      if (this.failed || (shareEnvironment().mobile && this.linkUrl)) this.open()
    },
    async open(qr) {
      if (this.loading) return
      if (typeof qr !== 'boolean') qr = !shareEnvironment().mobile
      const version = this._version
      const current = () => this._alive && version === this._version
      this.loading = true; this.failed = false
      try {
        if (this.standalone && !this.code) throw new Error('missing_share_code')
        if (!qr && this.path && await inMiniProgram()) {
          if (!current()) return
          await new Promise((resolve, reject) => window.wx.miniProgram.navigateTo({ url: '/' + this.path.replace(/^\//, '') + (this.query ? '?' + this.query : ''), success: resolve, fail: reject }))
          return
        }
        if (!current()) return
        let destination = qr ? this.codeImage : this.linkUrl
        if (!destination) {
          const response = this.code
            ? await getUrlLinkByCode({ code: this.code, ispc: qr ? 1 : 0, ...(this.businessCode ? { business_code: 1 } : {}) })
            : await getMiniUrlLink({ path: this.path, data: this.query, ispc: qr ? 1 : 0 })
          if (!current()) return
          destination = miniDestination(response, qr)
        }
        if (qr) this.codeImage = destination
        else {
          this.linkUrl = destination
          if (this.standalone) window.location.replace(destination)
          else window.location.href = destination
        }
      } catch (_) { if (current()) this.failed = true }
      finally { if (current()) this.loading = false }
    }
  }
}
</script>

<style scoped>
.mini-entry { color: var(--modal-text); text-align: center; }
.mini-entry button { font: inherit; padding: 10px 18px; border: 0; border-radius: 12px; color: var(--modal-text); background: var(--ui-control-secondary); cursor: pointer; }
.mini-entry button:focus-visible { outline: 2px solid var(--modal-text); outline-offset: 2px; }
.mini-entry button:disabled { opacity: .5; cursor: default; }
.mini-entry-code img { display: block; width: 180px; height: 180px; margin: 20px auto 0; }
.mini-entry p { font-size: 14px; line-height: 1.5; color: var(--ui-secondary-text); }
/* Original share-link QR presentation; WeChat stays blank until URL Link opens. */
.legacy-share-page { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; padding-right: 2rem; padding-bottom: calc(10px + env(safe-area-inset-bottom)); background: #fff; color: #000; color-scheme: light; text-align: center; }
.legacy-share-content { height: 7rem; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: space-between; }
.legacy-share-image { width: 4.5rem; height: 4.5rem; }
.legacy-share-text { width: 100%; line-height: .9rem; text-align: center; }
.legacy-share-title { color: #000; font-size: .55rem; font-weight: 800; }
.legacy-share-subtitle { color: rgba(0, 0, 0, .4); font-size: .4rem; font-weight: 400; }
.legacy-share-text button { font: inherit; color: inherit; background: transparent; cursor: pointer; }
</style>
